import { useWhatsAppLead } from '@/hooks/useWhatsAppLead';

export default function WhatsAppButton() {
  const { openModal } = useWhatsAppLead();

  return (
    <button
      onClick={() => openModal('Sabit WhatsApp Butonu')}
      className="fixed bottom-8 right-8 z-50 flex items-center gap-3 bg-green-500 hover:bg-green-400 text-white px-4 py-3.5 rounded-2xl transition-all duration-300 hover:scale-105 cursor-pointer"
      style={{ boxShadow: '0 8px 30px rgba(37,211,102,0.4)' }}
    >
      <span className="w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-line text-2xl" />
      </span>
      <span className="hidden sm:block font-bold text-sm whitespace-nowrap">WhatsApp&apos;tan Yaz</span>
      <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 rounded-full animate-pulse-dot" />
    </button>
  );
}
